import React, { useState } from 'react';
import { Container, Typography, Card, CardContent, Grid, TextField, FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import { api } from '../api';

const SimulationPage = ({ state, refreshData }) => {
    const [mentionCount, setMentionCount] = useState(1);
    const [platform, setPlatform] = useState('simulation');
    const [sentiment, setSentiment] = useState('Positive');
    const [isSimulating, setIsSimulating] = useState(false);

    const handleSimulate = async () => {
        // --- THIS IS THE FIX ---
        // 1. Ensure the user has at least one keyword to associate the simulation with.
        if (!state.keywords || state.keywords.length === 0) {
            alert('Please add at least one keyword on the Keywords page before simulating mentions.');
            return;
        }
        
        setIsSimulating(true);
        try {
            const newMentions = [];
            // 2. Use the ID of the first available keyword.
            const firstKeywordId = state.keywords[0].id;

            for (let i = 0; i < mentionCount; i++) {
                newMentions.push({
                    platform: platform,
                    author: `Simulated User ${i + 1}`,
                    content: `This is a simulated ${sentiment.toLowerCase()} mention about JazzCash. Timestamp: ${Date.now()}`,
                    postUrl: `http://simulation.test/${Date.now() + i}`,
                    publishedAt: new Date(),
                    sentiment: sentiment,
                    keywordId: firstKeywordId
                });
            }
            await api.post(`/mentions/batch`, newMentions);
            alert(`${mentionCount} mentions simulated and saved. Refreshing data to check for alerts...`);
            await refreshData();
        } catch (err) {
            alert('Failed to simulate mentions.');
        } finally {
            setIsSimulating(false);
        }
    };

    return (
        <Container maxWidth="md">
            <Typography variant="h4" gutterBottom>Data Simulation</Typography>
            <Card><CardContent>
                <Typography variant="h6">Generate Dummy Data</Typography>
                <Typography variant="body2" color="text.secondary" sx={{mb: 2}}>Create fake mentions to test your dashboard and alert system.</Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}><TextField fullWidth label="Number of Mentions" type="number" value={mentionCount} onChange={e => setMentionCount(Math.max(1, e.target.value))} /></Grid>
                    <Grid item xs={12} sm={4}><FormControl fullWidth><InputLabel>Platform</InputLabel><Select value={platform} onChange={e => setPlatform(e.target.value)} label="Platform"><MenuItem value="simulation">Simulation</MenuItem><MenuItem value="twitter">Twitter</MenuItem></Select></FormControl></Grid>
                    <Grid item xs={12} sm={4}><FormControl fullWidth><InputLabel>Sentiment</InputLabel><Select value={sentiment} onChange={e => setSentiment(e.target.value)} label="Sentiment"><MenuItem value="Positive">Positive</MenuItem><MenuItem value="Negative">Negative</MenuItem><MenuItem value="Neutral">Neutral</MenuItem></Select></FormControl></Grid>
                </Grid>
                <Button fullWidth variant="contained" color="warning" onClick={handleSimulate} disabled={isSimulating} sx={{mt: 3}}>
                    {isSimulating ? 'Simulating...' : 'Run Simulation'}
                </Button>
            </CardContent></Card>
        </Container>
    );
};

export default SimulationPage;
